import { Collider } from "./Collider";
export async function loadParticlesCollisionsInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesCollisions", (container) => new Collider(container), refresh);
}
